var global = require("./global.js");
var vP4252 = require("../64.js");
var vP42522 = require("../65.js");
var vP42523 = require("./isArray.js");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT === undefined ? f527() : global.TYPED_ARRAY_SUPPORT;
exports.kMaxLength = f528();
function f527() {
  try {
    var v4154 = new Uint8Array(1);
    v4154.__proto__ = {
      __proto__: Uint8Array.prototype,
      foo: function () {
        return 42;
      }
    };
    return v4154.foo() === 42 && typeof v4154.subarray == "function" && v4154.subarray(1, 1).byteLength === 0;
  } catch (e27) {
    return false;
  }
}
function f528() {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    return 2147483647;
  } else {
    return 1073741823;
  }
}
function f529(p4254, p4255) {
  if (f528() < p4255) {
    throw new RangeError("Invalid typed array length");
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    p4254 = new Uint8Array(p4255);
    p4254.__proto__ = Buffer.prototype;
  } else {
    if (p4254 === null) {
      p4254 = new Buffer(p4255);
    }
    p4254.length = p4255;
  }
  return p4254;
}
function Buffer(p4256, p4257, p4258) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(p4256, p4257, p4258);
  }
  if (typeof p4256 == "number") {
    if (typeof p4257 == "string") {
      throw new Error("If encoding is specified then the first argument must be a string");
    }
    return f534(this, p4256);
  }
  return f531(this, p4256, p4257, p4258);
}
Buffer.poolSize = 8192;
Buffer._augment = function (p4259) {
  p4259.__proto__ = Buffer.prototype;
  return p4259;
};
function f531(p4260, p4261, p4262, p4263) {
  if (typeof p4261 == "number") {
    throw new TypeError("\"value\" argument must not be a number");
  }
  if (typeof ArrayBuffer != "undefined" && p4261 instanceof ArrayBuffer) {
    return f537(p4260, p4261, p4262, p4263);
  } else if (typeof p4261 == "string") {
    return f535(p4260, p4261, p4262);
  } else {
    return f538(p4260, p4261);
  }
}
Buffer.from = function (p4264, p4265, p4266) {
  return f531(null, p4264, p4265, p4266);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol != "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}
function f532(p4267) {
  if (typeof p4267 != "number") {
    throw new TypeError("\"size\" argument must be a number");
  } else if (p4267 < 0) {
    throw new RangeError("\"size\" argument must not be negative");
  }
}
function f533(p4268, p4269, p4270, p4271) {
  f532(p4269);
  if (p4269 <= 0) {
    return f529(p4268, p4269);
  } else if (p4270 === undefined) {
    return f529(p4268, p4269);
  } else if (typeof p4271 == "string") {
    return f529(p4268, p4269).fill(p4270, p4271);
  } else {
    return f529(p4268, p4269).fill(p4270);
  }
}
Buffer.alloc = function (p4272, p4273, p4274) {
  return f533(null, p4272, p4273, p4274);
};
function f534(p4275, p4276) {
  f532(p4276);
  p4275 = f529(p4275, p4276 < 0 ? 0 : f539(p4276) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var vLN0643 = 0; vLN0643 < p4276; ++vLN0643) {
      p4275[vLN0643] = 0;
    }
  }
  return p4275;
}
Buffer.allocUnsafe = function (p4277) {
  return f534(null, p4277);
};
Buffer.allocUnsafeSlow = function (p4278) {
  return f534(null, p4278);
};
function f535(p4279, p4280, p4281) {
  if (typeof p4281 != "string" || p4281 === "") {
    p4281 = "utf8";
  }
  if (!Buffer.isEncoding(p4281)) {
    throw new TypeError("\"encoding\" must be a valid string encoding");
  }
  var v4155 = f541(p4280, p4281) | 0;
  p4279 = f529(p4279, v4155);
  var v4156 = p4279.write(p4280, p4281);
  if (v4156 !== v4155) {
    p4279 = p4279.slice(0, v4156);
  }
  return p4279;
}
function f536(p4282, p4283) {
  var v4157 = p4283.length < 0 ? 0 : f539(p4283.length) | 0;
  p4282 = f529(p4282, v4157);
  for (var vLN0644 = 0; vLN0644 < v4157; vLN0644 += 1) {
    p4282[vLN0644] = p4283[vLN0644] & 255;
  }
  return p4282;
}
function f537(p4284, p4285, p4286, p4287) {
  p4285.byteLength;
  if (p4286 < 0 || p4285.byteLength < p4286) {
    throw new RangeError("'offset' is out of bounds");
  }
  if (p4285.byteLength < p4286 + (p4287 || 0)) {
    throw new RangeError("'length' is out of bounds");
  }
  p4285 = p4286 === undefined && p4287 === undefined ? new Uint8Array(p4285) : p4287 === undefined ? new Uint8Array(p4285, p4286) : new Uint8Array(p4285, p4286, p4287);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    p4284 = p4285;
    p4284.__proto__ = Buffer.prototype;
  } else {
    p4284 = f536(p4284, p4285);
  }
  return p4284;
}
function f538(p4288, p4289) {
  if (Buffer.isBuffer(p4289)) {
    var v4158 = f539(p4289.length) | 0;
    p4288 = f529(p4288, v4158);
    if (p4288.length === 0) {
      return p4288;
    } else {
      p4289.copy(p4288, 0, 0, v4158);
      return p4288;
    }
  }
  if (p4289) {
    if (typeof ArrayBuffer != "undefined" && p4289.buffer instanceof ArrayBuffer || "length" in p4289) {
      if (typeof p4289.length != "number" || f575(p4289.length)) {
        return f529(p4288, 0);
      } else {
        return f536(p4288, p4289);
      }
    }
    if (p4289.type === "Buffer" && vP42523(p4289.data)) {
      return f536(p4288, p4289.data);
    }
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function f539(p4290) {
  if (p4290 >= f528()) {
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + f528().toString(16) + " bytes");
  }
  return p4290 | 0;
}
function SlowBuffer(p4291) {
  if (+p4291 != p4291) {
    p4291 = 0;
  }
  return Buffer.alloc(+p4291);
}
Buffer.isBuffer = function (p4292) {
  return p4292 != null && !!p4292._isBuffer;
};
Buffer.compare = function (p4293, p4294) {
  if (!Buffer.isBuffer(p4293) || !Buffer.isBuffer(p4294)) {
    throw new TypeError("Arguments must be Buffers");
  }
  if (p4293 === p4294) {
    return 0;
  }
  var v4159 = p4293.length;
  var v4160 = p4294.length;
  for (var vLN0645 = 0, v4161 = Math.min(v4159, v4160); vLN0645 < v4161; ++vLN0645) {
    if (p4293[vLN0645] !== p4294[vLN0645]) {
      v4159 = p4293[vLN0645];
      v4160 = p4294[vLN0645];
      break;
    }
  }
  if (v4159 < v4160) {
    return -1;
  } else if (v4160 < v4159) {
    return 1;
  } else {
    return 0;
  }
};
Buffer.isEncoding = function (p4295) {
  switch ((p4295 + "").toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return true;
    default:
      return false;
  }
};
Buffer.concat = function (p4296, p4297) {
  if (!vP42523(p4296)) {
    throw new TypeError("\"list\" argument must be an Array of Buffers");
  }
  if (p4296.length === 0) {
    return Buffer.alloc(0);
  }
  var v4162;
  if (p4297 === undefined) {
    p4297 = 0;
    v4162 = 0;
    for (; v4162 < p4296.length; ++v4162) {
      p4297 += p4296[v4162].length;
    }
  }
  var v4163 = Buffer.allocUnsafe(p4297);
  var vLN0646 = 0;
  for (v4162 = 0; v4162 < p4296.length; ++v4162) {
    var v4164 = p4296[v4162];
    if (!Buffer.isBuffer(v4164)) {
      throw new TypeError("\"list\" argument must be an Array of Buffers");
    }
    v4164.copy(v4163, vLN0646);
    vLN0646 += v4164.length;
  }
  return v4163;
};
function f541(p4298, p4299) {
  if (Buffer.isBuffer(p4298)) {
    return p4298.length;
  }
  if (typeof ArrayBuffer != "undefined" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(p4298) || p4298 instanceof ArrayBuffer)) {
    return p4298.byteLength;
  }
  if (typeof p4298 != "string") {
    p4298 = "" + p4298;
  }
  var v4165 = p4298.length;
  if (v4165 === 0) {
    return 0;
  }
  var v4166 = false;
  for (;;) {
    switch (p4299) {
      case "ascii":
      case "latin1":
      case "binary":
        return v4165;
      case "utf8":
      case "utf-8":
      case undefined:
        return f570(p4298).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return v4165 * 2;
      case "hex":
        return v4165 >>> 1;
      case "base64":
        return f573(p4298).length;
      default:
        if (v4166) {
          return f570(p4298).length;
        }
        p4299 = ("" + p4299).toLowerCase();
        v4166 = true;
    }
  }
}
Buffer.byteLength = f541;
function f542(p4300, p4301, p4302) {
  var v4167 = false;
  if (p4301 === undefined || p4301 < 0) {
    p4301 = 0;
  }
  if (p4301 > this.length) {
    return "";
  }
  if (p4302 === undefined || p4302 > this.length) {
    p4302 = this.length;
  }
  if (p4302 <= 0) {
    return "";
  }
  p4302 >>>= 0;
  p4301 >>>= 0;
  if (p4302 <= p4301) {
    return "";
  }
  for (p4300 ||= "utf8";;) {
    switch (p4300) {
      case "hex":
        return f558(this, p4301, p4302);
      case "utf8":
      case "utf-8":
        return f554(this, p4301, p4302);
      case "ascii":
        return f556(this, p4301, p4302);
      case "latin1":
      case "binary":
        return f557(this, p4301, p4302);
      case "base64":
        return f553(this, p4301, p4302);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return f559(this, p4301, p4302);
      default:
        if (v4167) {
          throw new TypeError("Unknown encoding: " + p4300);
        }
        p4300 = (p4300 + "").toLowerCase();
        v4167 = true;
    }
  }
}
Buffer.prototype._isBuffer = true;
function f543(p4303, p4304, p4305) {
  var v4168 = p4303[p4304];
  p4303[p4304] = p4303[p4305];
  p4303[p4305] = v4168;
}
Buffer.prototype.swap16 = function () {
  var v4169 = this.length;
  if (v4169 % 2 != 0) {
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  }
  for (var vLN0647 = 0; vLN0647 < v4169; vLN0647 += 2) {
    f543(this, vLN0647, vLN0647 + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function () {
  var v4170 = this.length;
  if (v4170 % 4 != 0) {
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  }
  for (var vLN0648 = 0; vLN0648 < v4170; vLN0648 += 4) {
    f543(this, vLN0648, vLN0648 + 3);
    f543(this, vLN0648 + 1, vLN0648 + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function () {
  var v4171 = this.length;
  if (v4171 % 8 != 0) {
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  }
  for (var vLN0649 = 0; vLN0649 < v4171; vLN0649 += 8) {
    f543(this, vLN0649, vLN0649 + 7);
    f543(this, vLN0649 + 1, vLN0649 + 6);
    f543(this, vLN0649 + 2, vLN0649 + 5);
    f543(this, vLN0649 + 3, vLN0649 + 4);
  }
  return this;
};
Buffer.prototype.toString = function () {
  var v4172 = this.length | 0;
  if (v4172 == 0) {
    return "";
  } else if (arguments.length === 0) {
    return f554(this, 0, v4172);
  } else {
    return f542.apply(this, arguments);
  }
};
Buffer.prototype.equals = function (p4306) {
  if (!Buffer.isBuffer(p4306)) {
    throw new TypeError("Argument must be a Buffer");
  }
  return this === p4306 || Buffer.compare(this, p4306) === 0;
};
Buffer.prototype.inspect = function () {
  var vLS7 = "";
  var v4173 = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    vLS7 = this.toString("hex", 0, v4173).match(/.{2}/g).join(" ");
    if (this.length > v4173) {
      vLS7 += " ... ";
    }
  }
  return "<Buffer " + vLS7 + ">";
};
Buffer.prototype.compare = function (p4307, p4308, p4309, p4310, p4311) {
  if (!Buffer.isBuffer(p4307)) {
    throw new TypeError("Argument must be a Buffer");
  }
  if (p4308 === undefined) {
    p4308 = 0;
  }
  if (p4309 === undefined) {
    p4309 = p4307 ? p4307.length : 0;
  }
  if (p4310 === undefined) {
    p4310 = 0;
  }
  if (p4311 === undefined) {
    p4311 = this.length;
  }
  if (p4308 < 0 || p4309 > p4307.length || p4310 < 0 || p4311 > this.length) {
    throw new RangeError("out of range index");
  }
  if (p4310 >= p4311 && p4308 >= p4309) {
    return 0;
  }
  if (p4310 >= p4311) {
    return -1;
  }
  if (p4308 >= p4309) {
    return 1;
  }
  p4308 >>>= 0;
  p4309 >>>= 0;
  p4310 >>>= 0;
  p4311 >>>= 0;
  if (this === p4307) {
    return 0;
  }
  var v4174 = p4311 - p4310;
  var v4175 = p4309 - p4308;
  for (var v4176 = Math.min(v4174, v4175), v4177 = this.slice(p4310, p4311), v4178 = p4307.slice(p4308, p4309), vLN0650 = 0; vLN0650 < v4176; ++vLN0650) {
    if (v4177[vLN0650] !== v4178[vLN0650]) {
      v4174 = v4177[vLN0650];
      v4175 = v4178[vLN0650];
      break;
    }
  }
  if (v4174 < v4175) {
    return -1;
  } else if (v4175 < v4174) {
    return 1;
  } else {
    return 0;
  }
};
function f544(p4312, p4313, p4314, p4315, p4316) {
  if (p4312.length === 0) {
    return -1;
  }
  if (typeof p4314 == "string") {
    p4315 = p4314;
    p4314 = 0;
  } else if (p4314 > 2147483647) {
    p4314 = 2147483647;
  } else if (p4314 < -2147483648) {
    p4314 = -2147483648;
  }
  p4314 = +p4314;
  if (isNaN(p4314)) {
    p4314 = p4316 ? 0 : p4312.length - 1;
  }
  if (p4314 < 0) {
    p4314 = p4312.length + p4314;
  }
  if (p4314 >= p4312.length) {
    if (p4316) {
      return -1;
    }
    p4314 = p4312.length - 1;
  } else if (p4314 < 0) {
    if (p4316) {
      p4314 = 0;
    } else {
      return -1;
    }
  }
  if (typeof p4313 == "string") {
    p4313 = Buffer.from(p4313, p4315);
  }
  if (Buffer.isBuffer(p4313)) {
    if (p4313.length === 0) {
      return -1;
    } else {
      return f545(p4312, p4313, p4314, p4315, p4316);
    }
  }
  if (typeof p4313 == "number") {
    p4313 &= 255;
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function") {
      if (p4316) {
        return Uint8Array.prototype.indexOf.call(p4312, p4313, p4314);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(p4312, p4313, p4314);
      }
    } else {
      return f545(p4312, [p4313], p4314, p4315, p4316);
    }
  }
  throw new TypeError("val must be string, number or Buffer");
}
function f545(p4317, p4318, p4319, p4320, p4321) {
  function f546(p4322, p4323) {
    if (vLN164 === 1) {
      return p4322[p4323];
    } else {
      return p4322.readUInt16BE(p4323 * vLN164);
    }
  }
  var vLN164 = 1;
  var v4179 = p4317.length;
  var v4180 = p4318.length;
  if (p4320 !== undefined && (p4320 = (p4320 + "").toLowerCase(), p4320 === "ucs2" || p4320 === "ucs-2" || p4320 === "utf16le" || p4320 === "utf-16le")) {
    if (p4317.length < 2 || p4318.length < 2) {
      return -1;
    }
    vLN164 = 2;
    v4179 /= 2;
    v4180 /= 2;
    p4319 /= 2;
  }
  var v4181;
  if (p4321) {
    var v4182 = -1;
    for (v4181 = p4319; v4181 < v4179; v4181++) {
      if (f546(p4317, v4181) !== f546(p4318, v4182 === -1 ? 0 : v4181 - v4182)) {
        if (v4182 !== -1) {
          v4181 -= v4181 - v4182;
        }
        v4182 = -1;
      } else {
        if (v4182 === -1) {
          v4182 = v4181;
        }
        if (v4181 - v4182 + 1 === v4180) {
          return v4182 * vLN164;
        }
      }
    }
  } else {
    if (p4319 + v4180 > v4179) {
      p4319 = v4179 - v4180;
    }
    v4181 = p4319;
    if (p4319 + v4180 > v4179) {
      p4319 = v4179 - v4180;
    }
    v4181 = p4319;
    for (; v4181 >= 0; v4181--) {
      var v4183 = true;
      for (var vLN0651 = 0; vLN0651 < v4180; vLN0651++) {
        if (f546(p4317, v4181 + vLN0651) !== f546(p4318, vLN0651)) {
          v4183 = false;
          break;
        }
      }
      if (v4183) {
        return v4181;
      }
    }
  }
  return -1;
}
Buffer.prototype.includes = function (p4324, p4325, p4326) {
  return this.indexOf(p4324, p4325, p4326) !== -1;
};
Buffer.prototype.indexOf = function (p4327, p4328, p4329) {
  return f544(this, p4327, p4328, p4329, true);
};
Buffer.prototype.lastIndexOf = function (p4330, p4331, p4332) {
  return f544(this, p4330, p4331, p4332, false);
};
function f547(p4333, p4334, p4335, p4336) {
  p4335 = +p4335 || 0;
  var v4184 = p4333.length - p4335;
  if (p4336) {
    p4336 = +p4336;
    if (p4336 > v4184) {
      p4336 = v4184;
    }
  } else {
    p4336 = v4184;
  }
  var v4185 = p4334.length;
  if (v4185 % 2 != 0) {
    throw new TypeError("Invalid hex string");
  }
  if (p4336 > v4185 / 2) {
    p4336 = v4185 / 2;
  }
  var v4186;
  for (var vLN0652 = 0; vLN0652 < p4336; ++vLN0652) {
    v4186 = parseInt(p4334.substr(vLN0652 * 2, 2), 16);
    if (isNaN(v4186)) {
      return vLN0652;
    }
    p4333[p4335 + vLN0652] = v4186;
  }
  return vLN0652;
}
function f548(p4337, p4338, p4339, p4340) {
  return f574(f570(p4338, p4337.length - p4339), p4337, p4339, p4340);
}
function f549(p4341, p4342, p4343, p4344) {
  return f574(f571(p4342), p4341, p4343, p4344);
}
function f550(p4345, p4346, p4347, p4348) {
  return f549(p4345, p4346, p4347, p4348);
}
function f551(p4349, p4350, p4351, p4352) {
  return f574(f573(p4350), p4349, p4351, p4352);
}
function f552(p4353, p4354, p4355, p4356) {
  return f574(f572(p4354, p4353.length - p4355), p4353, p4355, p4356);
}
Buffer.prototype.write = function (p4357, p4358, p4359, p4360) {
  if (p4358 === undefined) {
    p4360 = "utf8";
    p4359 = this.length;
    p4358 = 0;
  } else if (p4359 === undefined && typeof p4358 == "string") {
    p4360 = p4358;
    p4359 = this.length;
    p4358 = 0;
  } else if (isFinite(p4358)) {
    p4358 |= 0;
    if (isFinite(p4359)) {
      p4359 |= 0;
      if (p4360 === undefined) {
        p4360 = "utf8";
      }
    } else {
      p4360 = p4359;
      p4359 = undefined;
    }
  } else {
    throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
  }
  var v4187 = this.length - p4358;
  if (p4359 === undefined || p4359 > v4187) {
    p4359 = v4187;
  }
  if (p4357.length > 0 && (p4359 < 0 || p4358 < 0) || p4358 > this.length) {
    throw new RangeError("Attempt to write outside buffer bounds");
  }
  if (!p4360) {
    p4360 = "utf8";
  }
  var v4188 = false;
  for (;;) {
    switch (p4360) {
      case "hex":
        return f547(this, p4357, p4358, p4359);
      case "utf8":
      case "utf-8":
        return f548(this, p4357, p4358, p4359);
      case "ascii":
        return f549(this, p4357, p4358, p4359);
      case "latin1":
      case "binary":
        return f550(this, p4357, p4358, p4359);
      case "base64":
        return f551(this, p4357, p4358, p4359);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return f552(this, p4357, p4358, p4359);
      default:
        if (v4188) {
          throw new TypeError("Unknown encoding: " + p4360);
        }
        p4360 = ("" + p4360).toLowerCase();
        v4188 = true;
    }
  }
};
Buffer.prototype.toJSON = function () {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function f553(p4361, p4362, p4363) {
  if (p4362 === 0 && p4363 === p4361.length) {
    return vP4252.fromByteArray(p4361);
  } else {
    return vP4252.fromByteArray(p4361.slice(p4362, p4363));
  }
}
function f554(p4364, p4365, p4366) {
  p4366 = Math.min(p4364.length, p4366);
  var vA215 = [];
  for (var vP4365 = p4365; vP4365 < p4366;) {
    var v4189 = p4364[vP4365];
    var v4190 = null;
    var v4191 = v4189 > 239 ? 4 : v4189 > 223 ? 3 : v4189 > 191 ? 2 : 1;
    if (vP4365 + v4191 <= p4366) {
      var v4192;
      var v4193;
      var v4194;
      var v4195;
      if (v4191 === 1) {
        if (v4189 < 128) {
          v4190 = v4189;
        }
      } else if (v4191 === 2) {
        v4192 = p4364[vP4365 + 1];
        if ((v4192 & 192) == 128) {
          v4195 = (v4189 & 31) << 6 | v4192 & 63;
          if (v4195 > 127) {
            v4190 = v4195;
          }
        }
      } else if (v4191 === 3) {
        v4192 = p4364[vP4365 + 1];
        v4193 = p4364[vP4365 + 2];
        if ((v4192 & 192) == 128 && (v4193 & 192) == 128) {
          v4195 = (v4189 & 15) << 12 | (v4192 & 63) << 6 | v4193 & 63;
          if (v4195 > 2047 && (v4195 < 55296 || v4195 > 57343)) {
            v4190 = v4195;
          }
        }
      } else if (v4191 === 4) {
        v4192 = p4364[vP4365 + 1];
        v4193 = p4364[vP4365 + 2];
        v4194 = p4364[vP4365 + 3];
        if ((v4192 & 192) == 128 && (v4193 & 192) == 128 && (v4194 & 192) == 128) {
          v4195 = (v4189 & 15) << 18 | (v4192 & 63) << 12 | (v4193 & 63) << 6 | v4194 & 63;
          if (v4195 > 65535 && v4195 < 1114112) {
            v4190 = v4195;
          }
        }
      } else {
        undefined;
      }
    }
    if (v4190 === null) {
      v4190 = 65533;
      v4191 = 1;
    } else if (v4190 > 65535) {
      v4190 -= 65536;
      vA215.push(v4190 >>> 10 & 1023 | 55296);
      v4190 = v4190 & 1023 | 56320;
    }
    vA215.push(v4190);
    vP4365 += v4191;
  }
  return f555(vA215);
}
var vLN4096 = 4096;
function f555(p4367) {
  var v4196 = p4367.length;
  if (v4196 <= vLN4096) {
    return String.fromCharCode.apply(String, p4367);
  }
  var vLS8 = "";
  for (var vLN0653 = 0; vLN0653 < v4196;) {
    vLS8 += String.fromCharCode.apply(String, p4367.slice(vLN0653, vLN0653 += vLN4096));
  }
  return vLS8;
}
function f556(p4368, p4369, p4370) {
  var vLS9 = "";
  p4370 = Math.min(p4368.length, p4370);
  for (var vP4369 = p4369; vP4369 < p4370; ++vP4369) {
    vLS9 += String.fromCharCode(p4368[vP4369] & 127);
  }
  return vLS9;
}
function f557(p4371, p4372, p4373) {
  var vLS10 = "";
  p4373 = Math.min(p4371.length, p4373);
  for (var vP4372 = p4372; vP4372 < p4373; ++vP4372) {
    vLS10 += String.fromCharCode(p4371[vP4372]);
  }
  return vLS10;
}
function f558(p4374, p4375, p4376) {
  var v4197 = p4374.length;
  if (!p4375 || p4375 < 0) {
    p4375 = 0;
  }
  if (!p4376 || p4376 < 0 || p4376 > v4197) {
    p4376 = v4197;
  }
  var vLS11 = "";
  for (var vP4375 = p4375; vP4375 < p4376; ++vP4375) {
    vLS11 += f569(p4374[vP4375]);
  }
  return vLS11;
}
function f559(p4377, p4378, p4379) {
  for (var v4198 = p4377.slice(p4378, p4379), vLS12 = "", vLN0654 = 0; vLN0654 < v4198.length; vLN0654 += 2) {
    vLS12 += String.fromCharCode(v4198[vLN0654] + v4198[vLN0654 + 1] * 256);
  }
  return vLS12;
}
Buffer.prototype.slice = function (p4380, p4381) {
  var v4199 = this.length;
  p4380 = ~~p4380;
  p4381 = p4381 === undefined ? v4199 : ~~p4381;
  if (p4380 < 0) {
    p4380 += v4199;
    if (p4380 < 0) {
      p4380 = 0;
    }
  } else if (p4380 > v4199) {
    p4380 = v4199;
  }
  if (p4381 < 0) {
    p4381 += v4199;
    if (p4381 < 0) {
      p4381 = 0;
    }
  } else if (p4381 > v4199) {
    p4381 = v4199;
  }
  if (p4381 < p4380) {
    p4381 = p4380;
  }
  var v4200;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    v4200 = this.subarray(p4380, p4381);
    v4200.__proto__ = Buffer.prototype;
  } else {
    var v4201 = p4381 - p4380;
    v4200 = new Buffer(v4201, undefined);
    for (var vLN0655 = 0; vLN0655 < v4201; ++vLN0655) {
      v4200[vLN0655] = this[vLN0655 + p4380];
    }
  }
  return v4200;
};
function f560(p4382, p4383, p4384) {
  if (p4382 % 1 != 0 || p4382 < 0) {
    throw new RangeError("offset is not uint");
  }
  if (p4382 + p4383 > p4384) {
    throw new RangeError("Trying to access beyond buffer length");
  }
}
Buffer.prototype.readUIntLE = function (p4385, p4386, p4387) {
  p4385 |= 0;
  p4386 |= 0;
  if (!p4387) {
    f560(p4385, p4386, this.length);
  }
  var v4202 = this[p4385];
  for (var vLN165 = 1, vLN0656 = 0; ++vLN0656 < p4386 && (vLN165 *= 256);) {
    v4202 += this[p4385 + vLN0656] * vLN165;
  }
  return v4202;
};
Buffer.prototype.readUIntBE = function (p4388, p4389, p4390) {
  p4388 |= 0;
  p4389 |= 0;
  if (!p4390) {
    f560(p4388, p4389, this.length);
  }
  var v4203 = this[p4388 + --p4389];
  for (var vLN166 = 1; p4389 > 0 && (vLN166 *= 256);) {
    v4203 += this[p4388 + --p4389] * vLN166;
  }
  return v4203;
};
Buffer.prototype.readUInt8 = function (p4391, p4392) {
  if (!p4392) {
    f560(p4391, 1, this.length);
  }
  return this[p4391];
};
Buffer.prototype.readUInt16LE = function (p4393, p4394) {
  if (!p4394) {
    f560(p4393, 2, this.length);
  }
  return this[p4393] | this[p4393 + 1] << 8;
};
Buffer.prototype.readUInt16BE = function (p4395, p4396) {
  if (!p4396) {
    f560(p4395, 2, this.length);
  }
  return this[p4395] << 8 | this[p4395 + 1];
};
Buffer.prototype.readUInt32LE = function (p4397, p4398) {
  if (!p4398) {
    f560(p4397, 4, this.length);
  }
  return (this[p4397] | this[p4397 + 1] << 8 | this[p4397 + 2] << 16) + this[p4397 + 3] * 16777216;
};
Buffer.prototype.readUInt32BE = function (p4399, p4400) {
  if (!p4400) {
    f560(p4399, 4, this.length);
  }
  return this[p4399] * 16777216 + (this[p4399 + 1] << 16 | this[p4399 + 2] << 8 | this[p4399 + 3]);
};
Buffer.prototype.readIntLE = function (p4401, p4402, p4403) {
  p4401 |= 0;
  p4402 |= 0;
  if (!p4403) {
    f560(p4401, p4402, this.length);
  }
  var v4204 = this[p4401];
  for (var vLN167 = 1, vLN0657 = 0; ++vLN0657 < p4402 && (vLN167 *= 256);) {
    v4204 += this[p4401 + vLN0657] * vLN167;
  }
  vLN167 *= 128;
  if (v4204 >= vLN167) {
    v4204 -= Math.pow(2, p4402 * 8);
  }
  return v4204;
};
Buffer.prototype.readIntBE = function (p4404, p4405, p4406) {
  p4404 |= 0;
  p4405 |= 0;
  if (!p4406) {
    f560(p4404, p4405, this.length);
  }
  for (var vP4405 = p4405, vLN168 = 1, v4205 = this[p4404 + --vP4405]; vP4405 > 0 && (vLN168 *= 256);) {
    v4205 += this[p4404 + --vP4405] * vLN168;
  }
  vLN168 *= 128;
  if (v4205 >= vLN168) {
    v4205 -= Math.pow(2, p4405 * 8);
  }
  return v4205;
};
Buffer.prototype.readInt8 = function (p4407, p4408) {
  if (!p4408) {
    f560(p4407, 1, this.length);
  }
  if (this[p4407] & 128) {
    return (255 - this[p4407] + 1) * -1;
  } else {
    return this[p4407];
  }
};
Buffer.prototype.readInt16LE = function (p4409, p4410) {
  if (!p4410) {
    f560(p4409, 2, this.length);
  }
  var v4206 = this[p4409] | this[p4409 + 1] << 8;
  if (v4206 & 32768) {
    return v4206 | -65536;
  } else {
    return v4206;
  }
};
Buffer.prototype.readInt16BE = function (p4411, p4412) {
  if (!p4412) {
    f560(p4411, 2, this.length);
  }
  var v4207 = this[p4411 + 1] | this[p4411] << 8;
  if (v4207 & 32768) {
    return v4207 | -65536;
  } else {
    return v4207;
  }
};
Buffer.prototype.readInt32LE = function (p4413, p4414) {
  if (!p4414) {
    f560(p4413, 4, this.length);
  }
  return this[p4413] | this[p4413 + 1] << 8 | this[p4413 + 2] << 16 | this[p4413 + 3] << 24;
};
Buffer.prototype.readInt32BE = function (p4415, p4416) {
  if (!p4416) {
    f560(p4415, 4, this.length);
  }
  return this[p4415] << 24 | this[p4415 + 1] << 16 | this[p4415 + 2] << 8 | this[p4415 + 3];
};
Buffer.prototype.readFloatLE = function (p4417, p4418) {
  if (!p4418) {
    f560(p4417, 4, this.length);
  }
  return vP42522.read(this, p4417, true, 23, 4);
};
Buffer.prototype.readFloatBE = function (p4419, p4420) {
  if (!p4420) {
    f560(p4419, 4, this.length);
  }
  return vP42522.read(this, p4419, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function (p4421, p4422) {
  if (!p4422) {
    f560(p4421, 8, this.length);
  }
  return vP42522.read(this, p4421, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function (p4423, p4424) {
  if (!p4424) {
    f560(p4423, 8, this.length);
  }
  return vP42522.read(this, p4423, false, 52, 8);
};
function f561(p4425, p4426, p4427, p4428, p4429, p4430) {
  if (!Buffer.isBuffer(p4425)) {
    throw new TypeError("\"buffer\" argument must be a Buffer instance");
  }
  if (p4426 > p4429 || p4426 < p4430) {
    throw new RangeError("\"value\" argument is out of bounds");
  }
  if (p4427 + p4428 > p4425.length) {
    throw new RangeError("Index out of range");
  }
}
Buffer.prototype.writeUIntLE = function (p4431, p4432, p4433, p4434) {
  p4431 = +p4431;
  p4432 |= 0;
  p4433 |= 0;
  if (!p4434) {
    var v4208 = Math.pow(2, p4433 * 8) - 1;
    f561(this, p4431, p4432, p4433, v4208, 0);
  }
  var vLN169 = 1;
  var vLN0658 = 0;
  for (this[p4432] = p4431 & 255; ++vLN0658 < p4433 && (vLN169 *= 256);) {
    this[p4432 + vLN0658] = p4431 / vLN169 & 255;
  }
  return p4432 + p4433;
};
Buffer.prototype.writeUIntBE = function (p4435, p4436, p4437, p4438) {
  p4435 = +p4435;
  p4436 |= 0;
  p4437 |= 0;
  if (!p4438) {
    var v4209 = Math.pow(2, p4437 * 8) - 1;
    f561(this, p4435, p4436, p4437, v4209, 0);
  }
  var v4210 = p4437 - 1;
  var vLN170 = 1;
  for (this[p4436 + v4210] = p4435 & 255; --v4210 >= 0 && (vLN170 *= 256);) {
    this[p4436 + v4210] = p4435 / vLN170 & 255;
  }
  return p4436 + p4437;
};
Buffer.prototype.writeUInt8 = function (p4439, p4440, p4441) {
  p4439 = +p4439;
  p4440 |= 0;
  if (!p4441) {
    f561(this, p4439, p4440, 1, 255, 0);
  }
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    p4439 = Math.floor(p4439);
  }
  this[p4440] = p4439 & 255;
  return p4440 + 1;
};
function f562(p4442, p4443, p4444, p4445) {
  if (p4443 < 0) {
    p4443 = 65535 + p4443 + 1;
  }
  for (var vLN0659 = 0, v4211 = Math.min(p4442.length - p4444, 2); vLN0659 < v4211; ++vLN0659) {
    p4442[p4444 + vLN0659] = (p4443 & 255 << (p4445 ? vLN0659 : 1 - vLN0659) * 8) >>> (p4445 ? vLN0659 : 1 - vLN0659) * 8;
  }
}
Buffer.prototype.writeUInt16LE = function (p4446, p4447, p4448) {
  p4446 = +p4446;
  p4447 |= 0;
  if (!p4448) {
    f561(this, p4446, p4447, 2, 65535, 0);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4447] = p4446 & 255;
    this[p4447 + 1] = p4446 >>> 8;
  } else {
    f562(this, p4446, p4447, true);
  }
  return p4447 + 2;
};
Buffer.prototype.writeUInt16BE = function (p4449, p4450, p4451) {
  p4449 = +p4449;
  p4450 |= 0;
  if (!p4451) {
    f561(this, p4449, p4450, 2, 65535, 0);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4450] = p4449 >>> 8;
    this[p4450 + 1] = p4449 & 255;
  } else {
    f562(this, p4449, p4450, false);
  }
  return p4450 + 2;
};
function f563(p4452, p4453, p4454, p4455) {
  if (p4453 < 0) {
    p4453 = 4294967295 + p4453 + 1;
  }
  for (var vLN0660 = 0, v4212 = Math.min(p4452.length - p4454, 4); vLN0660 < v4212; ++vLN0660) {
    p4452[p4454 + vLN0660] = p4453 >>> (p4455 ? vLN0660 : 3 - vLN0660) * 8 & 255;
  }
}
Buffer.prototype.writeUInt32LE = function (p4456, p4457, p4458) {
  p4456 = +p4456;
  p4457 |= 0;
  if (!p4458) {
    f561(this, p4456, p4457, 4, 4294967295, 0);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4457 + 3] = p4456 >>> 24;
    this[p4457 + 2] = p4456 >>> 16;
    this[p4457 + 1] = p4456 >>> 8;
    this[p4457] = p4456 & 255;
  } else {
    f563(this, p4456, p4457, true);
  }
  return p4457 + 4;
};
Buffer.prototype.writeUInt32BE = function (p4459, p4460, p4461) {
  p4459 = +p4459;
  p4460 |= 0;
  if (!p4461) {
    f561(this, p4459, p4460, 4, 4294967295, 0);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4460] = p4459 >>> 24;
    this[p4460 + 1] = p4459 >>> 16;
    this[p4460 + 2] = p4459 >>> 8;
    this[p4460 + 3] = p4459 & 255;
  } else {
    f563(this, p4459, p4460, false);
  }
  return p4460 + 4;
};
Buffer.prototype.writeIntLE = function (p4462, p4463, p4464, p4465) {
  p4462 = +p4462;
  p4463 |= 0;
  if (!p4465) {
    var v4213 = Math.pow(2, p4464 * 8 - 1);
    f561(this, p4462, p4463, p4464, v4213 - 1, -v4213);
  }
  var vLN0661 = 0;
  var vLN171 = 1;
  var vLN0662 = 0;
  for (this[p4463] = p4462 & 255; ++vLN0661 < p4464 && (vLN171 *= 256);) {
    if (p4462 < 0 && vLN0662 === 0 && this[p4463 + vLN0661 - 1] !== 0) {
      vLN0662 = 1;
    }
    this[p4463 + vLN0661] = (p4462 / vLN171 >> 0) - vLN0662 & 255;
  }
  return p4463 + p4464;
};
Buffer.prototype.writeIntBE = function (p4466, p4467, p4468, p4469) {
  p4466 = +p4466;
  p4467 |= 0;
  if (!p4469) {
    var v4214 = Math.pow(2, p4468 * 8 - 1);
    f561(this, p4466, p4467, p4468, v4214 - 1, -v4214);
  }
  var v4215 = p4468 - 1;
  var vLN172 = 1;
  var vLN0663 = 0;
  for (this[p4467 + v4215] = p4466 & 255; --v4215 >= 0 && (vLN172 *= 256);) {
    if (p4466 < 0 && vLN0663 === 0 && this[p4467 + v4215 + 1] !== 0) {
      vLN0663 = 1;
    }
    this[p4467 + v4215] = (p4466 / vLN172 >> 0) - vLN0663 & 255;
  }
  return p4467 + p4468;
};
Buffer.prototype.writeInt8 = function (p4470, p4471, p4472) {
  p4470 = +p4470;
  p4471 |= 0;
  if (!p4472) {
    f561(this, p4470, p4471, 1, 127, -128);
  }
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    p4470 = Math.floor(p4470);
  }
  if (p4470 < 0) {
    p4470 = 255 + p4470 + 1;
  }
  this[p4471] = p4470 & 255;
  return p4471 + 1;
};
Buffer.prototype.writeInt16LE = function (p4473, p4474, p4475) {
  p4473 = +p4473;
  p4474 |= 0;
  if (!p4475) {
    f561(this, p4473, p4474, 2, 32767, -32768);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4474] = p4473 & 255;
    this[p4474 + 1] = p4473 >>> 8;
  } else {
    f562(this, p4473, p4474, true);
  }
  return p4474 + 2;
};
Buffer.prototype.writeInt16BE = function (p4476, p4477, p4478) {
  p4476 = +p4476;
  p4477 |= 0;
  if (!p4478) {
    f561(this, p4476, p4477, 2, 32767, -32768);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4477] = p4476 >>> 8;
    this[p4477 + 1] = p4476 & 255;
  } else {
    f562(this, p4476, p4477, false);
  }
  return p4477 + 2;
};
Buffer.prototype.writeInt32LE = function (p4479, p4480, p4481) {
  p4479 = +p4479;
  p4480 |= 0;
  if (!p4481) {
    f561(this, p4479, p4480, 4, 2147483647, -2147483648);
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4480] = p4479 & 255;
    this[p4480 + 1] = p4479 >>> 8;
    this[p4480 + 2] = p4479 >>> 16;
    this[p4480 + 3] = p4479 >>> 24;
  } else {
    f563(this, p4479, p4480, true);
  }
  return p4480 + 4;
};
Buffer.prototype.writeInt32BE = function (p4482, p4483, p4484) {
  p4482 = +p4482;
  p4483 |= 0;
  if (!p4484) {
    f561(this, p4482, p4483, 4, 2147483647, -2147483648);
  }
  if (p4482 < 0) {
    p4482 = 4294967295 + p4482 + 1;
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[p4483] = p4482 >>> 24;
    this[p4483 + 1] = p4482 >>> 16;
    this[p4483 + 2] = p4482 >>> 8;
    this[p4483 + 3] = p4482 & 255;
  } else {
    f563(this, p4482, p4483, false);
  }
  return p4483 + 4;
};
function f564(p4485, p4486, p4487, p4488) {
  if (p4487 + p4488 > p4485.length) {
    throw new RangeError("Index out of range");
  }
  if (p4487 < 0) {
    throw new RangeError("Index out of range");
  }
}
function f565(p4489, p4490, p4491, p4492, p4493) {
  if (!p4493) {
    f564(p4489, p4490, p4491, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  vP42522.write(p4489, p4490, p4491, p4492, 23, 4);
  return p4491 + 4;
}
Buffer.prototype.writeFloatLE = function (p4494, p4495, p4496) {
  return f565(this, p4494, p4495, true, p4496);
};
Buffer.prototype.writeFloatBE = function (p4497, p4498, p4499) {
  return f565(this, p4497, p4498, false, p4499);
};
function f566(p4500, p4501, p4502, p4503, p4504) {
  if (!p4504) {
    f564(p4500, p4501, p4502, 8, 1.7976931348623157e+308, -1.7976931348623157e+308);
  }
  vP42522.write(p4500, p4501, p4502, p4503, 52, 8);
  return p4502 + 8;
}
Buffer.prototype.writeDoubleLE = function (p4505, p4506, p4507) {
  return f566(this, p4505, p4506, true, p4507);
};
Buffer.prototype.writeDoubleBE = function (p4508, p4509, p4510) {
  return f566(this, p4508, p4509, false, p4510);
};
Buffer.prototype.copy = function (p4511, p4512, p4513, p4514) {
  if (!p4513) {
    p4513 = 0;
  }
  if (!p4514 && p4514 !== 0) {
    p4514 = this.length;
  }
  if (p4512 >= p4511.length) {
    p4512 = p4511.length;
  }
  if (!p4512) {
    p4512 = 0;
  }
  if (p4514 > 0 && p4514 < p4513) {
    p4514 = p4513;
  }
  if (p4514 === p4513) {
    return 0;
  }
  if (p4511.length === 0 || this.length === 0) {
    return 0;
  }
  if (p4512 < 0) {
    throw new RangeError("targetStart out of bounds");
  }
  if (p4513 < 0 || p4513 >= this.length) {
    throw new RangeError("sourceStart out of bounds");
  }
  if (p4514 < 0) {
    throw new RangeError("sourceEnd out of bounds");
  }
  if (p4514 > this.length) {
    p4514 = this.length;
  }
  if (p4511.length - p4512 < p4514 - p4513) {
    p4514 = p4511.length - p4512 + p4513;
  }
  var v4216;
  var v4217 = p4514 - p4513;
  if (this === p4511 && p4513 < p4512 && p4512 < p4514) {
    for (v4216 = v4217 - 1; v4216 >= 0; --v4216) {
      p4511[v4216 + p4512] = this[v4216 + p4513];
    }
  } else if (v4217 < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    for (v4216 = 0; v4216 < v4217; ++v4216) {
      p4511[v4216 + p4512] = this[v4216 + p4513];
    }
  } else {
    Uint8Array.prototype.set.call(p4511, this.subarray(p4513, p4513 + v4217), p4512);
  }
  return v4217;
};
Buffer.prototype.fill = function (p4515, p4516, p4517, p4518) {
  if (typeof p4515 == "string") {
    if (typeof p4516 == "string") {
      p4518 = p4516;
      p4516 = 0;
      p4517 = this.length;
    } else if (typeof p4517 == "string") {
      p4518 = p4517;
      p4517 = this.length;
    }
    if (p4515.length === 1) {
      var v4218 = p4515.charCodeAt(0);
      if (v4218 < 256) {
        p4515 = v4218;
      }
    }
    if (p4518 !== undefined && typeof p4518 != "string") {
      throw new TypeError("encoding must be a string");
    }
    if (typeof p4518 == "string" && !Buffer.isEncoding(p4518)) {
      throw new TypeError("Unknown encoding: " + p4518);
    }
  } else if (typeof p4515 == "number") {
    p4515 &= 255;
  }
  if (p4516 < 0 || this.length < p4516 || this.length < p4517) {
    throw new RangeError("Out of range index");
  }
  if (p4517 <= p4516) {
    return this;
  }
  p4516 >>>= 0;
  p4517 = p4517 === undefined ? this.length : p4517 >>> 0;
  if (!p4515) {
    p4515 = 0;
  }
  var v4219;
  if (typeof p4515 == "number") {
    for (v4219 = p4516; v4219 < p4517; ++v4219) {
      this[v4219] = p4515;
    }
  } else {
    var v4220 = Buffer.isBuffer(p4515) ? p4515 : f570(new Buffer(p4515, p4518).toString());
    var v4221 = v4220.length;
    for (v4219 = 0; v4219 < p4517 - p4516; ++v4219) {
      this[v4219 + p4516] = v4220[v4219 % v4221];
    }
  }
  return this;
};
var v4222 = /[^+\/0-9A-Za-z-_]/g;
function f567(p4519) {
  p4519 = f568(p4519).replace(v4222, "");
  if (p4519.length < 2) {
    return "";
  }
  while (p4519.length % 4 != 0) {
    p4519 += "=";
  }
  return p4519;
}
function f568(p4520) {
  if (p4520.trim) {
    return p4520.trim();
  } else {
    return p4520.replace(/^\s+|\s+$/g, "");
  }
}
function f569(p4521) {
  if (p4521 < 16) {
    return "0" + p4521.toString(16);
  } else {
    return p4521.toString(16);
  }
}
function f570(p4522, p4523) {
  p4523 = p4523 || Infinity;
  var v4223;
  for (var v4224 = p4522.length, v4225 = null, vA216 = [], vLN0664 = 0; vLN0664 < v4224; ++vLN0664) {
    v4223 = p4522.charCodeAt(vLN0664);
    if (v4223 > 55295 && v4223 < 57344) {
      if (!v4225) {
        if (v4223 > 56319) {
          if ((p4523 -= 3) > -1) {
            vA216.push(239, 191, 189);
          }
          continue;
        } else if (vLN0664 + 1 === v4224) {
          if ((p4523 -= 3) > -1) {
            vA216.push(239, 191, 189);
          }
          continue;
        }
        v4225 = v4223;
        continue;
      }
      if (v4223 < 56320) {
        if ((p4523 -= 3) > -1) {
          vA216.push(239, 191, 189);
        }
        v4225 = v4223;
        continue;
      }
      v4223 = (v4225 - 55296 << 10 | v4223 - 56320) + 65536;
    } else if (v4225 && (p4523 -= 3) > -1) {
      vA216.push(239, 191, 189);
    }
    v4225 = null;
    if (v4223 < 128) {
      if ((p4523 -= 1) < 0) {
        break;
      }
      vA216.push(v4223);
    } else if (v4223 < 2048) {
      if ((p4523 -= 2) < 0) {
        break;
      }
      vA216.push(v4223 >> 6 | 192, v4223 & 63 | 128);
    } else if (v4223 < 65536) {
      if ((p4523 -= 3) < 0) {
        break;
      }
      vA216.push(v4223 >> 12 | 224, v4223 >> 6 & 63 | 128, v4223 & 63 | 128);
    } else if (v4223 < 1114112) {
      if ((p4523 -= 4) < 0) {
        break;
      }
      vA216.push(v4223 >> 18 | 240, v4223 >> 12 & 63 | 128, v4223 >> 6 & 63 | 128, v4223 & 63 | 128);
    } else {
      throw new Error("Invalid code point");
    }
  }
  return vA216;
}
function f571(p4524) {
  var vA217 = [];
  for (var vLN0665 = 0; vLN0665 < p4524.length; ++vLN0665) {
    vA217.push(p4524.charCodeAt(vLN0665) & 255);
  }
  return vA217;
}
function f572(p4525, p4526) {
  var v4226;
  var v4227;
  var v4228;
  var vA218 = [];
  for (var vLN0666 = 0; vLN0666 < p4525.length && !((p4526 -= 2) < 0); ++vLN0666) {
    v4226 = p4525.charCodeAt(vLN0666);
    v4227 = v4226 >> 8;
    v4228 = v4226 % 256;
    vA218.push(v4228);
    vA218.push(v4227);
  }
  return vA218;
}
function f573(p4527) {
  return vP4252.toByteArray(f567(p4527));
}
function f574(p4528, p4529, p4530, p4531) {
  for (var vLN0667 = 0; vLN0667 < p4531 && !(vLN0667 + p4530 >= p4529.length) && !(vLN0667 >= p4528.length); ++vLN0667) {
    p4529[vLN0667 + p4530] = p4528[vLN0667];
  }
  return vLN0667;
}
function f575(p4532) {
  return p4532 !== p4532;
}